import Glide from '@glidejs/glide'

// Hero section
const hero = {
  init() {

    const sliders = document.querySelectorAll('.hero__slider')
    const config = {
      type: 'carousel',
      autoplay: 6000,
      animationDuration: 1000,
      animationTiming: 'ease-in-out',
      keyboard: true,
      touchDistance: 60,
    }

    const buttonTheme = (Glide, Components, Events) => {
      const Component =  {
        mount() {
          this.setButtonTheme()
        },
        setButtonTheme() {
          const theme = Components.Html.slides[Glide.index].dataset.theme
          const controls = Array.from(Components.Controls.items)
          const bullets = controls.find(item => item.classList.contains('glide__bullets'))
          if (theme === 'light-text') {
            bullets.classList.add('light-theme')
          } else {
            bullets.classList.remove('light-theme')
          }
        }
      }

      Events.on('run.after', () => {
        Component.setButtonTheme()
      })

      return Component
    }

    const addShopifyBlockBehavior = (slider) => {
      document.addEventListener('shopify:block:select', (event) => {
        if(slider.selector.contains(event.target)) {
          const index = event.target.dataset.index
          slider.go(`=${index}`)
          setTimeout(() => slider.disable(), 1000)
        }
      })

      document.addEventListener('shopify:block:deselect', () => {
        slider.enable()
      })
    }

    if(sliders) {
      sliders.forEach(item => {
        const slider = new Glide(item, config).mount({ buttonTheme })
        addShopifyBlockBehavior(slider)
      })

      document.addEventListener('shopify:section:load', (event) => {
        const sliderEl = event.target.querySelector('.hero__slider')
        if (sliderEl) {
          const slider = new Glide(sliderEl, config).mount({ buttonTheme })
          addShopifyBlockBehavior(slider)
        }
      })
    }
  }
}

export default hero